import { useRef } from 'react';

import { FileInput, FileInputProps } from '@components/file-field/file-input';
import { IconButton } from '@components/icon-button';
import { IconAttachment } from '@components/icons/attachment';

export type FileIconButtonProps = Pick<FileInputProps, 'fileType'> & {
  onFileSelected(file: File): void;
  size?: 'sm' | 'md' | 'lg';
};

export const FileIconButton = ({ onFileSelected, fileType, size }: FileIconButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <FileInput fileType={fileType} ref={fileInputRef} onChange={onFileSelected} />
      <IconButton
        onClick={() => fileInputRef.current?.click()}
        icon={<IconAttachment rotateDegrees={45} flipHorizontal />}
        size={size}
      />
    </>
  );
};
